export default {
    driver_performance_events_drawer_event: "Evento",
    driver_performance_events_drawer_when: "Fecha/Hora",
    driver_performance_events_drawer_driver: "Conductor",
    driver_performance_events_drawer_asset: "Activo",
    driver_performance_events_drawer_no_data: "No hay información disponible",
    driver_performance_events_drawer_severity: "Severidad",
    driver_performance_events_drawer_category: "Categoría",
    driver_performance_events_drawer_risk: "Riesgo",
    driver_performance_events_drawer_source: "Origen",
    driver_performance_events_drawer_camera: "Cámara",
    driver_performance_events_drawer_event_type: "Tipo de Evento",
    driver_performance_events_drawer_status: "Estado",
    driver_performance_events_drawer_driver_challenged: "Cuestionado por Conductor",
    driver_performance_highlightcoaching: "Destacar Coaching",
    driver_performance_falsepositive: "Falso Positivo",
    driver_performance_verified: "Verificado",
    driver_performance_noissue: "Sin Problema",
    driver_performance_severity_warning: "Advertencia",
    driver_performance_severity_default: "Predeterminado",
    driver_performance_severity_medium: "Medio",
    driver_performance_severity_low: "Bajo",
    driver_performance_severity_high: "Alto",
    driver_performance_severity_critical: "Crítico",
    driver_performance_unassigned: "Sin Asignar",
};
